// Firestore rejects `undefined`. Drop blank strings, blank objects, and empty
// arrays so the saved document stays clean and the Recipe page doesn't render
// stray placeholders for fields the user never filled in.
export function clean<T>(v: T): T | undefined {
  if (v === undefined || v === null) return undefined;
  if (typeof v === "string") {
    const t = v.trim();
    return (t === "" ? undefined : (t as unknown as T));
  }
  if (Array.isArray(v)) {
    const arr = v.map(clean).filter((x) => x !== undefined);
    return (arr.length === 0 ? undefined : (arr as unknown as T));
  }
  if (typeof v === "object") {
    const out: Record<string, unknown> = {};
    for (const [k, val] of Object.entries(v as Record<string, unknown>)) {
      const c = clean(val);
      if (c !== undefined) out[k] = c;
    }
    return (Object.keys(out).length === 0 ? undefined : (out as unknown as T));
  }
  if (typeof v === "number") {
    return (Number.isFinite(v) ? v : undefined);
  }
  return v;
}

export function parseNum(s: string): number | undefined {
  if (s.trim() === "") return undefined;
  const n = Number(s);
  return Number.isFinite(n) ? n : undefined;
}
